
        <!-- 交易流水 -->
<template>
 <!-- <vue-scroll :ops="ops" style="width:100%;min-height:95%;"> -->
    <div class="financeSetA"> 

       
   <div class="navCalss">
       | 仓库地址
   </div>
         <el-form
        :model="stores"
        :rules="stores.form_rules"
        ref="search"
     
        label-position="left"
      >
  <div class='felx'>
      <div style="flex:1">
       <div class="space">
           国内集货仓地址：
       </div>
       <div class="spaceTop">
          <el-form-item prop="address"  >
     <el-input v-model="stores.address" style="width:30vw" placeholder="地址：江苏太仓沙溪沙南西路1658号"></el-input>
      </el-form-item>
       </div>
         <div class="spaceTop">
          <el-form-item prop="contacts"  >
     <el-input v-model="stores.contacts" style="width:30vw" placeholder="收货人：李庆中"></el-input>
      </el-form-item>
       </div>
         <div class="spaceTop">
          <el-form-item prop="tel"  >
     <el-input v-model="stores.tel" style="width:30vw" placeholder="电话：13901620438"></el-input>
      </el-form-item>
       </div>
      </div>
      <div style="flex:1">
    <div class="space">
           国外集货仓地址：
       </div>
       <div class="spaceTop">
         <el-form-item prop="addressO"  >
     <el-input v-model="stores.addressO" style="width:30vw" placeholder="地址：江苏太仓沙溪沙南西路1658号"></el-input>
      </el-form-item>
        <div class="spaceTop">
          <el-form-item prop="contactsO"  >
     <el-input v-model="stores.contactsO" style="width:30vw" placeholder="联系人：Justin Biber"></el-input>
      </el-form-item>
       </div>
         <div class="spaceTop">
          <el-form-item prop="telO"  >
     <el-input v-model="stores.telO" style="width:30vw" placeholder="电话：+14082029128"></el-input>
      </el-form-item>
       </div>
       </div>
      </div>
  </div>
   
         </el-form>
         <div class="fotet">
             <div>
             <el-button @click="onsub" type="primary" style="margin-left:-8vw">确认修改</el-button>
             </div>
         </div>
    </div>
    <!-- </vue-scroll> -->
</template>
<script>
import * as mUtils from 'utils/mUtils'
import * as address from '@/api/address'
import Draggable from "vuedraggable"
  import Sortable from 'sortablejs'
  import FileSaver from 'file-saver'
	import XLSX from 'xlsx'
    import {
        axios
    } from 'utils/'
export default {
      components: {
    Draggable
  },
    data() {
        let dataValidate = (rule, value, callback) => {
           
            let that=this
      if (value === "") {
        let text;
        if (rule.field == "contacts") {
          text = "收货人";
        } else if (rule.field == "tel") {
          text = "电话";
        }
         else if (rule.field == "address") {
          text = "地址";
        }
         else if (rule.field == "contactsO") {
          text = "联系人";
        } 
        else if (rule.field == "telO") {
          text = "电话";
        }  else if (rule.field == "addressO") {
          text = "地址";
        }
    
        callback(new Error(text + "不能为空~"));
      } else {
           if (rule.field == "editPrice") {
          let numReg = /^[0-9]$/;
          if (!numReg.test(value)) {
             
            callback(new Error("请输入数字"));
          }else {
              if(numReg>0){
                 callback(new Error("请输入大于0数字"));
              }
               
          }
        }
        return callback();
      }
    };
  
        return {
            editStatus:true,
        salePrice:'3.8',
        stores:{
        contacts:'',
        tel:'',
        address:'',
          contactsO:'',
        telO:'',
        addressO:'',
             //信息修改规则
        form_rules: {
          contacts: [
           {
              required: true,
              validator: dataValidate,
              
              trigger: "blur"
            }
          ],
             tel: [
           {
              required: true,
              validator: dataValidate,
              
              trigger: "blur"
            }
          ],
             address: [
           {
              required: true,
              validator: dataValidate,
              
              trigger: "blur"
            }
          ],
           contactsO: [
           {
              required: true,
              validator: dataValidate,
              
              trigger: "blur"
            }
          ],
             telO: [
           {
              required: true,
              validator: dataValidate,
              
              trigger: "blur"
            }
          ],
             addressO: [
           {
              required: true,
              validator: dataValidate,
              
              trigger: "blur"
            }
          ],
        }
        }
        }
    },
    created() {
        let that=this
     that.getStore()
    },
    methods: {
      getStore(){
  let that = this
             
                 const loading = this.$loading({
					lock: true,
					text: 'loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
                });
     
        setTimeout(function(){
              loading.close();
            },5000)
            let data={
                   storeType:1

                  }
                  
                address.getStore(data)
        .then((res)=> {
          if(res.data.code == 0) {
      
               that.stores.contacts=res.data.data.contacts
             that.stores.address=res.data.data.address
               that.stores.tel=res.data.data.tel
             
          }else{
               that.$message.error('获取失败 !')
          }
        })
          let dataA={
                   storeType:2

                  }
                  
                address.getStore(dataA)
        .then((res)=> {
          if(res.data.code == 0) {
            that.stores.contactsO=res.data.data.contacts
             that.stores.addressO=res.data.data.address
               that.stores.telO=res.data.data.tel
             
          }else{
               that.$message.error('获取失败 !')
          }
        })
                   loading.close();
      },
        onsub(){
            let that = this
             
                 const loading = this.$loading({
					lock: true,
					text: 'loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
                });
     
        setTimeout(function(){
              loading.close();
            },5000)
 let validd
            that.$refs.search.validate((valid) => {
                validd = valid;
    
                return true
            }) 
           
            if(validd){
              let obj={}
              obj.storeType=1
              obj.address=that.stores.address
                obj.contacts=that.stores.contacts
                  obj.tel=that.stores.tel
                  let arr=[]
                  arr.push(obj)
                  obj={}
                  obj.storeType=2
              obj.address=that.stores.addressO
                obj.contacts=that.stores.contactsO
                  obj.tel=that.stores.telO
                    arr.push(obj)
                  let data={
                    storeList:arr,
                    operatorId:mUtils.getStore('userinfo').adminId,

                  }
                  
                address.updateStore(data)
        .then((res)=> {
          if(res.data.code == 0) {
            
                that.$message.success('提交成功 !') 
                that.getStore()
          }else{
               that.$message.error('提交错误 !')
          }
        })
                   loading.close();
       }else{
                 that.$message.error('表单输入错误 !')
                loading.close();
                return false
            }
        },
    edit(){
        let that=this
         that.editPrice=that.salePrice
        that.editStatus=false
       
    },
    editB(){
          let that=this
        //  that.editPrice=that.salePrice
        that.editStatus=true
    },
    }
}
</script>
<style  lang="less" scoped>
.felx{
    display: flex;
      margin:30px 0;
      .spaceTop{
          margin:20px 0; 
      }
}
.financeSetA{
    margin:20px 50px ;

.monewt{
    margin: 20px 0px;
    // border: 1px solid rgba(121, 121, 121, 1);
    min-height: 50px;
    min-width: 900px;
}
}
.pagination{
    margin: 20px 0;
}
.backakdia{
background:#DCDFE6 ;
line-height: 30px;
min-height: 30px;

}
  .ss{
		cursor: pointer;
		color: #409EFF;
  }
    .navCal{
      margin: 20px 0;
  
  }
    .navCalss{
          font-family: 'PingFangSC-Semibold', 'PingFang SC Semibold', 'PingFang SC', sans-serif;
    font-weight: 650;
        font-size: 18px ;
  }
  .fotet{
      display: flex;
      justify-content: center;
  }
</style>
<style>

   .navCal .is-active{
          background-color: rgba(2, 125, 180, 1);
          color: white !important;
      }
     .felx   .el-input__inner {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 60px;
    line-height: 60px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
}
       /* .scrt{
         overflow-x:hidden;
         overflow-y:scroll
       } */
</style>



// WEBPACK FOOTER //
// houserAddress.vue?3e832fe2